import request from '../utils/fetch'

export function getHouseInOrderCount (data) {
  return request({
    url: '/house/inorder/getHouseInOrderCount',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function getHouseInOrderInfo (data) {
  return request({
    url: '/house/inorder/getHouseInOrderInfo',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function getHouseInOrderList (data) {
  return request({
    url: '/house/inorder/getHouseInOrderList',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function editRemark (data) {
  return request({
    url: '/house/inorder/houseInStock',
    method: 'post',
    requestBody: 'body',
    loading: true,
    data: data
  })
}







